<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>Relatório de Contratos LAI</span>
                </h4>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <div>
                    <b-row>
                        <b-col sm="12" md="12">
                            <b-form-group>
                                <label
                                    for="selectListaContratos"
                                    class="required"
                                    >Contrato</label
                                >
                                <model-list-select
                                    id="selectListaContratos"
                                    :list="listaContratos"
                                    v-model="contrato"
                                    option-value="idContrato"
                                    option-text="textoFormatado"
                                    placeholder="Selecione um contrato"
                                ></model-list-select>
                                <div
                                    v-if="
                                        $v.contrato.$dirty &&
                                        $v.contrato.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    Contrato é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="5">
                            <b-form-group>
                                <label for="inputNome" class="required"
                                    >Nome da Entidade/Órgão - Sigla</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputNome"
                                        type="text"
                                        placeholder="Nome da Entidade/Órgão - Sigla"
                                        v-model="entidade"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.entidade.$dirty &&
                                            $v.entidade.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Nome da Entidade/Órgão - Sigla é
                                        obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="5">
                            <b-form-group>
                                <label for="inputContratada" class="required"
                                    >Contratada</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputContratada"
                                        type="text"
                                        placeholder="Contratada"
                                        v-model="contratada"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.contratada.$dirty &&
                                            $v.contratada.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Contratada é obrigatória
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label
                                    for="inputCnpjContratada"
                                    class="required"
                                    >CNPJ da Contratada</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputCnpjContratada"
                                        type="text"
                                        placeholder="CNPJ da Contratada"
                                        v-model="cnpj"
                                        v-mask="['##.###.###/####-##']"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.cnpj.$dirty && $v.cnpj.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        CNPJ da Contratada é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="12">
                            <b-form-group>
                                <label for="inputObjeto" class="required"
                                    >Objeto do Contrato</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputObjeto"
                                        type="text"
                                        placeholder="Objeto do Contrato"
                                        v-model="objeto"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.objeto.$dirty &&
                                            $v.objeto.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Objeto do Contrato é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label
                                    for="inputProcessoLicitatorio"
                                    >Nº Processo Licitatório</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputProcessoLicitatorio"
                                        type="text"
                                        placeholder="Nº Processo Licitatório"
                                        v-model="numeroProcessoLicitatorio"
                                        @input.native="
                                            $v.numeroProcessoLicitatorio.$touch()
                                        "
                                        @focus="
                                            $v.numeroProcessoLicitatorio.$touch()
                                        "
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.numeroProcessoLicitatorio
                                                .$dirty &&
                                            $v.numeroProcessoLicitatorio
                                                .$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Nº Processo Licitatório é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label
                                    for="inputModalidadeDeLicitacao"
                                    class="required"
                                    >Modalidade de Licitação</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputModalidadeDeLicitacao"
                                        type="text"
                                        placeholder="Modalidade de Licitação"
                                        v-model="modalidadeLicitacao"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.modalidadeLicitacao.$dirty &&
                                            $v.modalidadeLicitacao.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Modalidade de Licitação é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label
                                    for="inputNumeroContrato"
                                    class="required"
                                    >Nº do Contrato</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputNumeroContrato"
                                        type="text"
                                        placeholder="Nº do Contrato"
                                        v-model="numeroDoContrato"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.numeroDoContrato.$dirty &&
                                            $v.numeroDoContrato.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Nº do Contrato é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="inputAnoContrato" class="required"
                                    >Ano do Contrato</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputAnoContrato"
                                        type="number"
                                        placeholder="Ano do Contrato"
                                        min="1000"
                                        steps="1"
                                        v-model="anoDoContrato"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.anoDoContrato.$dirty &&
                                            $v.anoDoContrato.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Ano do Contrato é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label
                                    for="dateInicioDaVigencia"
                                    class="required"
                                    >Início da Vigência</label
                                >
                                <date-picker
                                    id="dateInicioDaVigencia"
                                    v-model="inicioDaVigencia"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                    :disabled="true"
                                ></date-picker>
                                <div
                                    v-if="
                                        $v.inicioDaVigencia.$dirty &&
                                        $v.inicioDaVigencia.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    Início da Vigência é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="dataFimDaVigencia" class="required"
                                    >Fim da Vigência</label
                                >
                                <date-picker
                                    id="dataFimDaVigencia"
                                    v-model="fimDaVigencia"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                    :disabled="true"
                                ></date-picker>
                                <div
                                    v-if="
                                        $v.fimDaVigencia.$dirty &&
                                        $v.fimDaVigencia.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    Fim da Vigência é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="inputAditivoDePrazo"
                                    >Aditivo de Prazo</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputAditivoDePrazo"
                                        type="number"
                                        placeholder="Aditivo de Prazo"
                                        v-model="aditivoDePrazo"
                                        @input.native="
                                            $v.aditivoDePrazo.$touch()
                                        "
                                        @focus="$v.aditivoDePrazo.$touch()"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="inputNumeroDoApostilamento"
                                    >Nº do Apostilamento</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputNumeroDoApostilamento"
                                        type="number"
                                        placeholder="Nº do Apostilamento"
                                        v-model="numeroDoApostilamento"
                                        @input.native="
                                            $v.numeroDoApostilamento.$touch()
                                        "
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="inputAditivoDeValor"
                                    >Aditivo de Valor</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputAditivoDeValor"
                                        type="number"
                                        placeholder="Aditivo de Valor"
                                        v-model="aditivoDeValor"
                                        @input.native="
                                            $v.aditivoDeValor.$touch()
                                        "
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="moValorMensal"
                                    >Valor Mensal</label
                                >
                                <b-input-group>
                                    <money
                                        id="moValorMensal"
                                        v-model="valorMensal"
                                        readonly
                                        v-bind="money"
                                        class="form-control text-right"
                                    ></money>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="moValorTotal" class="required"
                                    >Valor Total do Contrato</label
                                >
                                <b-input-group>
                                    <money
                                        id="moValorTotal"
                                        v-model="valorTotal"
                                        v-bind="money"
                                        class="form-control text-right"
                                        :disabled="true"
                                    ></money>
                                    <div
                                        v-if="
                                            $v.valorTotal.$dirty &&
                                            $v.valorTotal.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Valor Total do Contrato é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="moValorExecutado"
                                    >Valor Executado</label
                                >
                                <b-input-group>
                                    <money
                                        id="moValorExecutado"
                                        v-model="valorExecutado"
                                        readonly
                                        v-bind="money"
                                        class="form-control text-right"
                                    ></money>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="8">
                            <b-form-group>
                                <label for="inputNomeFiscal" class="required"
                                    >Nome do Fiscal do Contrato</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="inputNomeFiscal"
                                        type="text"
                                        placeholder="Nome do Fiscal do Contrato"
                                        v-model="nomeFiscal"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.nomeFiscal.$dirty &&
                                            $v.nomeFiscal.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Nome do Fiscal do Contrato é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label for="selectSituacao" class="required"
                                    >Situação</label
                                >
                                <b-input-group>
                                    <b-form-input
                                        id="selectSituacao"
                                        type="text"
                                        placeholder="Situação"
                                        v-model="situacao"
                                        readonly
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.situacao.$dirty &&
                                            $v.situacao.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Situação é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <b-row>
                    <b-col md="12">
                        <b-button
                            variant="primary"
                            class="mr-2 mt-3"
                            :disabled="desabilitarBtnSalvar"
                            @click.stop="salvar()"
                        >
                            <span>
                                <i class="fa fa-file-o mr-2"></i> {{ textoBotaoSalvar }}
                            </span>
                        </b-button>
                        <b-button
                            v-if="editandoId"
                            variant="secondary"
                            class="mt-3"
                            @click.stop="cancelarEdicao()"
                        >
                            <span>
                                <i class="fa fa-times mr-2"></i> Cancelar
                            </span>
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <h5 class="mt-4 mb-3">Histórico de Dados Adicionados</h5>
                        <app-tabela
                            :bordered="true"
                            :small="false"
                            :mostrarFiltro="false"
                            :itens="relatorios"
                            :campos="camposRelatorios"
                            :itensPorPagina="itensPorPagina">
                            <template slot="atualizadoEm" slot-scope="data">
                                <span class="text-nowrap">{{
                                    data.atualizadoEm
                                        ? $moment(data.atualizadoEm).format('DD/MM/YYYY HH:mm')
                                        : '-'
                                }}</span>
                            </template>
                            <template slot="valorTotalContrato" slot-scope="data">
                                <span class="text-nowrap">{{
                                data.valorTotalContrato | currency
                                }}</span>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <btn-detalhar :relatorio="data"></btn-detalhar>
                                <span class="text-primary mr-2">
                                    <i
                                        class="fa fa-pencil fa-lg icon-button"
                                        title="Editar"
                                        @click.stop="editarRelatorio(data)"
                                    ></i>
                                </span>
                                <span class="text-danger">
                                    <i
                                        class="fa fa-trash fa-lg icon-button"
                                        title="Deletar"
                                        @click.stop="confirmarDeletar(data)"
                                    ></i>
                                </span>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import { FormService, ContractService } from './services'
import { contractValidators } from './validators'
import GestaoJuridicaServicos from '../../GestaoJuridicaServicos'
import RelatoriosServicos from '../../../contratos/relatorios/RelatoriosServicos'
import BtnDetalhar from './BtnDetalhar.vue'

export default {
    components: {
        ModelListSelect,
        BtnDetalhar
    },

    methods: {
        salvar() {
            if (this.editandoId) {
                this.confirmarEdicao()
            } else {
                this.salvarRelatorio()
            }
        },

        confirmarEdicao() {
            this.$swal({
                title: 'Confirmar Edição',
                html: `
                    <p>Confirma a edição do relatório?</p>
                    <label for="swal-justificativa" style="display: block; margin-top: 15px; margin-bottom: 5px; font-weight: bold;">
                        Justificativa <span style="color: red;">*</span>
                    </label>
                    <textarea
                        id="swal-justificativa"
                        class="swal2-textarea"
                        placeholder="Informe a justificativa para a edição"
                        rows="4"
                        maxlength="200"
                        style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; font-family: inherit;"
                    ></textarea>
                    <div id="swal-justificativa-error" style="color: red; font-size: 12px; margin-top: 5px; display: none;">
                        Justificativa é obrigatória
                    </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
                focusConfirm: false,
                preConfirm: () => {
                    const justificativaInput = document.getElementById('swal-justificativa')
                    const errorDiv = document.getElementById('swal-justificativa-error')
                    const justificativa = justificativaInput ? justificativaInput.value.trim() : ''

                    if (!justificativa) {
                        if (errorDiv) {
                            errorDiv.style.display = 'block'
                        }
                        if (justificativaInput) {
                            justificativaInput.style.borderColor = 'red'
                            justificativaInput.focus()
                        }
                        return false
                    }

                    return justificativa
                },
                didOpen: () => {
                    setTimeout(() => {
                        const justificativaInput = document.getElementById('swal-justificativa')
                        const errorDiv = document.getElementById('swal-justificativa-error')

                        if (justificativaInput) {
                            justificativaInput.addEventListener('input', () => {
                                if (justificativaInput.value.length > 200) {
                                    justificativaInput.value = justificativaInput.value.substring(0, 200)
                                }

                                if (justificativaInput.value.trim()) {
                                    if (errorDiv) {
                                        errorDiv.style.display = 'none'
                                    }
                                    justificativaInput.style.borderColor = '#ddd'
                                } else {
                                    justificativaInput.style.borderColor = '#ddd'
                                }
                            })

                            justificativaInput.addEventListener('paste', (e) => {
                                setTimeout(() => {
                                    if (justificativaInput.value.length > 200) {
                                        justificativaInput.value = justificativaInput.value.substring(0, 200)
                                    }
                                }, 10)
                            })
                        }
                    }, 100)
                }
            }).then((result) => {
                if (result.value) {
                    this.justificativa = result.value
                    this.salvarRelatorio()
                }
            })
        },

        salvarRelatorio() {
            this.atualizado = this.$moment().format('DD/MM/YYYY HH:mm')

            const dto = FormService.buildDTO(this.$data)

            this.$store.dispatch('addRequest')

            if (this.editandoId) {
                RelatoriosServicos.editarRelatorioLAI(this.editandoId, dto)
                    .then((res) => {
                        if (res && res.success) {
                            this.limparCampos();
                            this.preencherDadosContrato(this.dadosContrato);
                            this.obterRelatoriosPorContrato()
                            this.$toast.success(
                                'Relatório atualizado com sucesso.',
                                'OK',
                                this.$toastConfig.success
                            )
                        } else {
                            this.$toast.error(
                                res.message || 'Falha ao atualizar relatório.',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    })
                    .catch((error) => {
                        this.$toast.error(
                            'Falha ao atualizar relatório.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    })
                    .finally(() => this.$store.dispatch('removeRequest'))
            } else {
                // Modo de criação
                GestaoJuridicaServicos.GerarPlanilhaRelatorioContratoLai(dto)
                    .then((res) => {
                        this.limparCampos();
                        this.preencherDadosContrato(this.dadosContrato);
                        this.obterRelatoriosPorContrato()
                        this.$toast.success(
                            'Relatório Salvo Com Sucesso.',
                            'OK',
                            this.$toastConfig.success
                        )
                    })
                    .catch((error) => {
                        this.$toast.error(
                            'Falha ao enviar ao backend.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    })
                    .finally(() => this.$store.dispatch('removeRequest'))
            }
        },

        verificarCampoPreenchido(value) {
            if (value == null || value == '' || value == undefined) return false
            else return true
        },

        abrirListaDePlanilha(cnpj) {
            this.$router.push({
                name: `Contratos_Relatorios_LAI`,
                params: {
                    cnpj: FormService.onlyDigits(cnpj)
                }
            })
        },

        async obterContratos() {
            this.$store.dispatch('addRequest')
            try {
                const response = await ContractService.getContracts(
                    GestaoJuridicaServicos
                )
                if (response && response.success) {
                    this.listaContratos = response.data
                    this.listaContratos = this.listaContratos.map((item) => {
                        return {
                            ...item,
                            textoFormatado: `${item.vcCodigoEstruturado} - ${item.fornecedor}`
                        }
                    })
                } else {
                    this.$toast.error(
                        'Erro ao obter lista de contratos!',
                        'ERRO',
                        this.$toastConfig.error
                    )
                }
            } catch (error) {
                this.$toast.error(
                    'Erro ao obter lista de contratos!',
                    'ERRO',
                    this.$toastConfig.error
                )
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        async obterDadosContrato() {
            this.$store.dispatch('addRequest')
            try {
                const response = await ContractService.getContractById(
                    GestaoJuridicaServicos,
                    this.contrato
                )
                if (response && response.success) {
                    this.dadosContrato = response.data;
                    this.preencherDadosContrato(response.data)
                    this.obterRelatoriosPorContrato()
                } else {
                    this.$toast.error(
                        'Erro ao obter contrato!',
                        'ERRO',
                        this.$toastConfig.error
                    )
                }
            } catch (error) {
                this.$toast.error(
                    'Erro ao obter contrato!',
                    'ERRO',
                    this.$toastConfig.error
                )
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        obterRelatoriosPorContrato() {
            if (!this.dadosContrato || !this.dadosContrato.idContrato) {
                this.relatorios = []
                return
            }

            const filtros = {
                contratoId: this.dadosContrato.idContrato
            }

            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterRelatoriosLAI(filtros).then((response) => {
                if (response) {
                    if (response.success) {
                        this.relatorios = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter relatórios!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                        this.relatorios = []
                    }
                }
                this.$store.dispatch('removeRequest')
            }).catch((error) => {
                this.$toast.error(
                    'Erro ao obter relatórios!',
                    'ERRO',
                    this.$toastConfig.error
                )
                this.relatorios = []
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarDeletar(relatorio) {
            this.$swal({
                title: 'Excluir',
                html: `
                    <p>Confirma a exclusão?</p>
                    <label for="swal-justificativa-excluir" style="display: block; margin-top: 15px; margin-bottom: 5px; font-weight: bold;">
                        Justificativa <span style="color: red;">*</span>
                    </label>
                    <textarea
                        id="swal-justificativa-excluir"
                        class="swal2-textarea"
                        placeholder="Informe a justificativa para a exclusão"
                        rows="4"
                        maxlength="200"
                        style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; font-family: inherit;"
                    ></textarea>
                    <div id="swal-justificativa-excluir-error" style="color: red; font-size: 12px; margin-top: 5px; display: none;">
                        Justificativa é obrigatória
                    </div>
                `,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                focusConfirm: false,
                preConfirm: () => {
                    const justificativaInput = document.getElementById('swal-justificativa-excluir')
                    const errorDiv = document.getElementById('swal-justificativa-excluir-error')
                    const justificativa = justificativaInput ? justificativaInput.value.trim() : ''

                    if (!justificativa) {
                        if (errorDiv) {
                            errorDiv.style.display = 'block'
                        }
                        if (justificativaInput) {
                            justificativaInput.style.borderColor = 'red'
                            justificativaInput.focus()
                        }
                        return false
                    }

                    return justificativa
                },
                didOpen: () => {
                    setTimeout(() => {
                        const justificativaInput = document.getElementById('swal-justificativa-excluir')
                        const errorDiv = document.getElementById('swal-justificativa-excluir-error')

                        if (justificativaInput) {
                            justificativaInput.addEventListener('input', () => {
                                if (justificativaInput.value.length > 200) {
                                    justificativaInput.value = justificativaInput.value.substring(0, 200)
                                }

                                if (justificativaInput.value.trim()) {
                                    if (errorDiv) {
                                        errorDiv.style.display = 'none'
                                    }
                                    justificativaInput.style.borderColor = '#ddd'
                                } else {
                                    justificativaInput.style.borderColor = '#ddd'
                                }
                            })

                            justificativaInput.addEventListener('paste', (e) => {
                                setTimeout(() => {
                                    if (justificativaInput.value.length > 200) {
                                        justificativaInput.value = justificativaInput.value.substring(0, 200)
                                    }
                                }, 10)
                            })
                        }
                    }, 100)
                }
            }).then(result => {
                if (result.value) {
                    this.excluirRelatorio(relatorio.id, result.value)
                }
            })
        },

        excluirRelatorio(id, justificativa) {
            this.$store.dispatch('addRequest')
            RelatoriosServicos
                .excluirRelatorioLAI(id, justificativa).then(response => {
                if (response) {
                    if (response.success) {
                        this.obterRelatoriosPorContrato()
                        this.$toast.success(
                            'Relatório excluído com sucesso.',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.relatorios = []
                        this.erros = response.errors
                        this.$toast.error(
                            response.message || 'Falha ao excluir relatório.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            }).catch((error) => {
                this.$toast.error(
                    'Falha ao excluir relatório.',
                    'ERRO',
                    this.$toastConfig.error
                )
                this.$store.dispatch('removeRequest')
            })
        },

        preencherDadosContrato(contrato) {
            ContractService.fillContractData(contrato, this.$data)
        },


        marcarCamposComoModificados() {
            this.$v.entidade.$touch()
            this.$v.atualizado.$touch()
            this.$v.contratada.$touch()
            this.$v.cnpj.$touch()
            this.$v.objeto.$touch()
            this.$v.numeroProcessoLicitatorio.$touch()
            this.$v.modalidadeLicitacao.$touch()
            this.$v.numeroDoContrato.$touch()
            this.$v.anoDoContrato.$touch()
            this.$v.inicioDaVigencia.$touch()
            this.$v.fimDaVigencia.$touch()
            this.$v.aditivoDePrazo.$touch()
            this.$v.numeroDoApostilamento.$touch()
            this.$v.aditivoDeValor.$touch()
            this.$v.valorTotal.$touch()
            this.$v.valorMensal.$touch()
            this.$v.valorExecutado.$touch()
            this.$v.nomeFiscal.$touch()
            this.$v.situacao.$touch()
        },

        limparCampos() {
            this.$v.$reset();
            this.editandoId = null
            this.entidade = null
            this.atualizado = null
            this.contratada = null
            this.cnpj = null
            this.objeto = null
            this.numeroProcessoLicitatorio = null
            this.modalidadeLicitacao = null
            this.numeroDoContrato = null
            this.anoDoContrato = null
            this.inicioDaVigencia = null
            this.fimDaVigencia = null
            this.aditivoDePrazo = null
            this.numeroDoApostilamento = null
            this.aditivoDeValor = null
            this.valorTotal = 0
            this.valorMensal = 0
            this.valorExecutado = 0
            this.nomeFiscal = null
            this.situacao = null
            this.justificativa = null
            this.relatorios = []
        },

        editarRelatorio(relatorio) {
            this.editandoId = relatorio.id

            this.entidade = relatorio.nomeEntidadeOuOrgao || null
            this.atualizado = relatorio.atualizadoEm
                ? this.$moment(relatorio.atualizadoEm).format('DD/MM/YYYY HH:mm')
                : null
            this.contratada = relatorio.contratada || null
            this.cnpj = relatorio.cnpjContratada || null
            this.objeto = relatorio.objeto || null
            this.numeroProcessoLicitatorio = relatorio.numeroProcessoLicitatorio || null
            this.modalidadeLicitacao = relatorio.modalidadeLicitacao || null
            this.numeroDoContrato = relatorio.numeroContrato || null
            this.anoDoContrato = relatorio.anoContrato || null
            this.inicioDaVigencia = relatorio.vigenciaInicio
                ? this.$moment(relatorio.vigenciaInicio).format('DD/MM/YYYY')
                : null
            this.fimDaVigencia = relatorio.vigenciaFim
                ? this.$moment(relatorio.vigenciaFim).format('DD/MM/YYYY')
                : null
            this.aditivoDePrazo = relatorio.aditivoPrazo
                ? this.removerOrdinal(relatorio.aditivoPrazo)
                : null
            this.numeroDoApostilamento = relatorio.numeroApostilamento
                ? this.removerOrdinal(relatorio.numeroApostilamento)
                : null
            this.aditivoDeValor = relatorio.aditivoValor
                ? this.removerOrdinal(relatorio.aditivoValor)
                : null
            this.valorTotal = relatorio.valorTotalContrato || 0
            this.valorMensal = relatorio.valorMensal || 0
            this.valorExecutado = relatorio.valorExecutado || 0
            this.nomeFiscal = relatorio.nomeFiscalContrato || null
            this.situacao = relatorio.situacao || null
            this.justificativa = null

            this.$nextTick(() => {
                const formElement = this.$el.querySelector('.card-body')
                if (formElement) {
                    formElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
            })
        },

        removerOrdinal(value) {
            if (!value) return null
            const str = String(value).trim()
            const semOrdinal = str.replace(/º$/, '')
            const numero = Number(semOrdinal)
            return !isNaN(numero) && isFinite(numero) ? numero : semOrdinal
        },

        cancelarEdicao() {
            this.editandoId = null
            this.$v.$reset()

            this.atualizado = null
            this.numeroProcessoLicitatorio = null
            this.aditivoDePrazo = null
            this.numeroDoApostilamento = null
            this.aditivoDeValor = null
            this.valorMensal = 0
            this.valorExecutado = 0
            this.justificativa = null

            if (this.dadosContrato) {
                this.preencherDadosContrato(this.dadosContrato)
            }
        }
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },
        textoBotaoSalvar() {
            return this.editandoId ? 'Concluir' : 'Salvar'
        }
    },
    validations: {
        contrato: { required: contractValidators.required },
        entidade: { required: contractValidators.required },
        cnpj: {
            required: contractValidators.required,
            cnpj: contractValidators.cnpj
        },
        contratada: { required: contractValidators.required },
        objeto: { required: contractValidators.required },
        numeroProcessoLicitatorio: {},
        modalidadeLicitacao: { required: contractValidators.required },
        numeroDoContrato: { required: contractValidators.required },
        anoDoContrato: {
            required: contractValidators.required,
            minValue: contractValidators.minValue(1000)
        },
        inicioDaVigencia: { required: contractValidators.required },
        fimDaVigencia: {
            required: contractValidators.required,
            afterStart() {
                return contractValidators.dateRange(
                    this.inicioDaVigencia,
                    this.fimDaVigencia
                )
            }
        },
        aditivoDePrazo: {},
        aditivoDeValor: {},
        numeroDoApostilamento: {},
        valorTotal: { required: contractValidators.required },
        valorMensal: {},
        valorExecutado: {},
        nomeFiscal: { required: contractValidators.required },
        situacao: { required: contractValidators.required }
    },
    data() {
        return {
            erros: [],
            listaSituacoes: [
                { codigo: 'Em Execução', nome: 'Em Execução' },
                { codigo: 'Encerrado', nome: 'Encerrado' }
            ],
            listaContratos: [],
            contrato: null,
            entidade: null,
            atualizado: null,
            contratada: null,
            cnpj: null,
            objeto: null,
            numeroProcessoLicitatorio: null,
            modalidadeLicitacao: null,
            numeroDoContrato: null,
            anoDoContrato: null,
            inicioDaVigencia: null,
            fimDaVigencia: null,
            aditivoDePrazo: null,
            numeroDoApostilamento: null,
            aditivoDeValor: null,
            valorTotal: 0,
            valorMensal: 0,
            valorExecutado: 0,
            nomeFiscal: null,
            situacao: null,
            justificativa: null,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            dadosContrato: null,
            relatorios: [],
            editandoId: null,
            camposRelatorios: [
                {
                    key: 'atualizadoEm',
                    label: 'Atualizado em',
                    filterable: true,
                    sortable: true,
                    type: 'date',
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    key: 'numeroContrato',
                    label: 'Número do Contrato',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'anoContrato',
                    label: 'Ano',
                    filterable: true,
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    key: 'objeto',
                    label: 'Objeto',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'valorTotalContrato',
                    label: 'Valor Total',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'criadoPor',
                    label: 'Criado por',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    mounted() {
        this.obterContratos()
    },

    watch: {
        contrato() {
            if (
                this.contrato !== null &&
                this.contrato !== undefined &&
                this.contrato !== ''
            ) {
                this.limparCampos()
                this.obterDadosContrato()
            } else {
                this.limparCampos()
                this.dadosContrato = null;
                this.relatorios = []
                this.$v.$reset()
            }
        }
    }
}
</script>

